import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { DateTime } from 'luxon';
import { CertificateFormVM } from 'front-office/view-models/certificate/certificate-form';
import { SearchApplicantHistorical } from 'shell/models/search-accountholder-historical';
import { DocumentRadioCertificate } from 'front-office/constants/document-radio-certificate';

export const transformerPersonGeneralityList = (
  response: AxiosResponse<HttpResponse<SearchApplicantHistorical>>
): CertificateFormVM => {
  const person = response.data.payload;

  return {
    isAire: person.aire,
    anomaly:
      person.noteAnomalie?.map((anomalia) => ({
        key: anomalia.key,
        code: anomalia.codiceAnomalia,
        description: anomalia.descrizioneNota,
        flag: anomalia.flagBlocco,
        insertDate: anomalia?.key?.dataAnnotazione
          ? DateTime.fromISO(anomalia.key?.dataAnnotazione).toFormat('dd/MM/yyyy')
          : undefined,
        cancelDate: anomalia?.dataCancellazione
          ? DateTime.fromISO(anomalia.dataCancellazione).toFormat('dd/MM/yyyy')
          : undefined,
      })) || [],
    certifiableApplicant: person.soggettoCertificabile || false,
    certifiableAccountholder: person.soggettoCertificabile || false,
    applicant: {
      fiscalCode: person.codiceFiscale || '',
      surname: person.cognome || '',
      name: person.nome || '',
      gender: person.sesso || '',
      withoutName: !person.nome ? true : false,
      withoutSurname: !person.cognome ? true : false,
      deathDate: person?.datiCancellazione?.dataDecorrenzaCancellazione
        ? DateTime.fromISO(person?.datiCancellazione?.dataDecorrenzaCancellazione)
        : null,
      birthDate: person.dataNascita ? DateTime.fromISO(person.dataNascita) : null,
    },
    generality: {
      birthDate: person.dataNascita ? DateTime.fromISO(person.dataNascita) : null,
      isForeign: person.statoEsteroNascita ? true : false,
      foreignStateBirth: person.statoEsteroNascita
        ? {
            id: person.codiceStatoEsteroNascita || '',
            value: person.statoEsteroNascita || '',
          }
        : null,
      provinceOfBirth: person.siglaProvinciaNascita || '',
      foreignMunicipality: person.statoEsteroNascita
        ? {
            id: person.codiceIstatComuneNascita || '',
            description: person.comuneNascita || '',
            province: person.siglaProvinciaNascita || '',
          }
        : null,
      // provinceOfBirth: person.generalita?.luogoNascita?.comune?.siglaProvinciaIstat || '',
      municipalityOfBirth: person.statoEsteroNascita
        ? null
        : {
            id: person.codiceIstatComuneNascita || '',
            description: person.comuneNascita || '',
            province: person.siglaProvinciaNascita || '',
          },
      // locality: person.generalita?.luogoNascita?.comune?.descrizioneLocalita,
      numberDocument: person.cartaIdentita || '',
      dateReleaseDocument: person.dataRilascioCartaIdentita
        ? DateTime.fromISO(person.dataRilascioCartaIdentita)
        : null,
      isForeignDocument: person.cartaIdentitaComuneRilascioEstero
        ? DocumentRadioCertificate.Other
        : DocumentRadioCertificate.IdentityCard,
      consulateCode: person.cartaIdentitaComuneRilascioEstero
        ? person.cartaIdentitaComuneRilascio
        : undefined,
      municipalityDocument: !person.cartaIdentitaComuneRilascioEstero
        ? {
            id: person.cartaIdentitaComuneRilascioIstat || '',
            description: person.cartaIdentitaComuneRilascio || '',
            province: person.cartaIdentitaComuneRilascioProvincia || '',
          }
        : null,
      // idSchedaSoggettoAnpr
      idSubjectAnpr: person.idSchedaSoggettoAnpr,
      documentString: `Documento di riconscimento ${person.cartaIdentita || ''} rilasciato il ${
        person.dataRilascioCartaIdentita
          ? DateTime.fromISO(person.dataRilascioCartaIdentita).toFormat('dd/MM/yyyy')
          : ''
      } da ${
        person.cartaIdentitaComuneRilascioEstero
          ? person.cartaIdentitaComuneRilascio
          : `Comune di ${person.cartaIdentitaComuneRilascio}`
      }`,
    },
  };
};
